// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover-content-wBHImj{-moz-column-gap:12px;box-sizing:content-box;background:#f4f4f6;border-radius:12px;justify-content:space-between;column-gap:12px;width:398px;height:128px;padding:24px;display:flex}.popover-content-wBHImj .input-content-ME3_kd{flex-direction:column;flex:1;justify-content:space-between;display:flex}.popover-content-wBHImj .confirm-button-O7h177{align-self:flex-end}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover-content": `popover-content-wBHImj`,
	"popoverContent": `popover-content-wBHImj`,
	"input-content": `input-content-ME3_kd`,
	"inputContent": `input-content-ME3_kd`,
	"confirm-button": `confirm-button-O7h177`,
	"confirmButton": `confirm-button-O7h177`
};
export default ___CSS_LOADER_EXPORT___;
